import api, { API_BASE } from "@/lib/api";

export async function openDocument(documentId) {
  const { data } = await api.get(`/documents/${documentId}`);
  const url = `${API_BASE}/documents/${documentId}/content?token=${data.signed_access_token}`;
  window.open(url, "_blank", "noopener,noreferrer");
}

// Inline preview: fetch the bytes with the same short-lived signed token, then frame a same-origin blob URL.
// The API keeps X-Frame-Options: DENY / frame-ancestors 'none' - nothing is relaxed; caller must revoke the URL.
export async function fetchDocumentBlobUrl(documentId) {
  const { data } = await api.get(`/documents/${documentId}`);
  const res = await fetch(`${API_BASE}/documents/${documentId}/content?token=${data.signed_access_token}`, { credentials: "include" });
  if (!res.ok) throw new Error(`Document fetch failed (${res.status})`);
  return { url: URL.createObjectURL(await res.blob()), title: data.title, contentType: res.headers.get("content-type") };
}
